<template>
  <div>
    <b-modal
        id="modal-delete-team"
        ref="modal-delete-team"
        footer-class="flex-nowrap"
        no-close-on-backdrop
        no-close-on-esc
        centered
    >
      <template #modal-header>
        <h3>{{ $t('modals.deleteTeam.title') }}</h3>
      </template>

      <template #default>
        <div class="delete-icon text-center">
          <b-icon icon="exclamation-triangle-fill" variant="danger" class="mt-5 mb-4"></b-icon>
          <div class="mt-2 mb-4">{{ $t('modals.deleteTeam.message') }}</div>
        </div>
      </template>

      <template #modal-footer>
        <b-button
            class="p-3 border-right-light-grey"
            block
            @click="cancelModal"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
            variant="primary"
            class="p-3"
            block
            @click="deleteTeam"
        >
          {{ $t('modals.deleteTeam.validate') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalDeleteTeam',
  props: ['team'],
  mounted() {
    this.$refs['modal-delete-team'].show();
  },
  methods: {
    deleteTeam() {
      this.$emit('deleteTeam');
    },
    cancelModal() {
      this.$emit('cancel');
    },
  },
};
</script>
